export const translationEngDefault = {
    SkhemataFaqPost: {
        "backToFaq": "Back to FAQ",
        "tags": "Tags",
        "categories": "Categories"
    }
};
//# sourceMappingURL=eng.js.map